<template>
  <certificates-panel />
</template>

<script>
import CertificatesPanel from '@/modules/Certificates/components/CertificatesPanel'
export default {
  name: 'CertificatesMain',
  components: {
    CertificatesPanel
  }
};
</script>